<template>
  <div class="progress-bar">
    <div class="progress-bar__fill" :style="{ width: percentage + '%' }" />
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    current: { type: Number, default: 0 },
    total: { type: Number, default: 8 },
  },
  computed: {
    percentage() {
      if (this.current <= 0) return 0
      return Math.min((this.current / this.total) * 100, 100)
    },
  },
}
</script>

<style lang="scss" scoped>
.progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.06);
  z-index: 100;

  &__fill {
    height: 100%;
    background: linear-gradient(90deg, var(--gold), var(--gold-light));
    border-radius: 0 2px 2px 0;
    transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }

}
</style>
